module.exports = __WEBPACK_EXTERNAL_MODULE_244__;


//////////////////
// WEBPACK FOOTER
// external "jszip"
// module id = 244
// module chunks = 0